export enum ContentType {
  JPEG = "image/jpeg",
  PDF = "application/pdf",
  PNG = "image/png",
  ZIP = "application/zip",
}
